import React, { useContext, useEffect, useState } from "react";
import PhotoVaultPictureAddForm from "../formzs/PhotoVaultPictureAddForm";
import { AuthContext } from "../../../../context/App-Context";
import axios from "axios";

const PhotoVaultPhotosItems = (props) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const auth = useContext(AuthContext);

  // 1. NEW: State to track which photo is currently fullscreen
  const [previewPhoto, setPreviewPhoto] = useState(null);

  useEffect(() => {
    setData(null);
    setError(null);
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${
            process.env.REACT_APP_BACKEND_URL
          }/zeusapolis/u-ablts/getPhotoVaultdatafromVaultwtgurl?username=${
            auth.loginVar
          }&albumKey=${encodeURIComponent(props.photoAlbumName)}`
        );
        setData(response.data);
      } catch (err) {
        // console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [props.photoVaultAlbumIndex, auth.loginVar, props.photoAlbumName]);

  if (loading) return <div className="photo-loading">Loading photos...</div>;
  if (error) return <div className="photo-error">Error: {error}</div>;

  if (!data?.images?.length) {
    return (
      <div className="photo-grid-empty">
        <p>No photos in this album yet</p>
      </div>
    );
  }

  return (
    <div>
      {/* 2. NEW: The Fullscreen Modal Overlay */}
      {previewPhoto && (
        <div
          className="photo-preview-modal"
          onClick={() => setPreviewPhoto(null)} // Clicking the dark background closes it
        >
          <button
            className="close-preview-btn"
            onClick={() => setPreviewPhoto(null)}
          >
            ×
          </button>
          <img
            src={previewPhoto}
            alt="Fullscreen preview"
            onClick={(e) => e.stopPropagation()} // Prevents clicking the image itself from closing the modal
          />
        </div>
      )}

      {/* 3. Your existing grid */}
      {data && (
        <div>
          <div className="photo-grid">
            {data.images.map((photo, index) => (
              <div
                key={
                  photo.key ||
                  photo.filename ||
                  `${props.photoAlbumName}-photo-${index}`
                }
                className="photo-item"
                // 4. NEW: Triggers the modal when clicking a grid photo
                onClick={() => setPreviewPhoto(photo.url || photo.src)}
                role="button"
                tabIndex={0}
              >
                <img
                  key={photo.filename}
                  src={photo.url || photo.src}
                  alt={photo.filename || `Photo ${index + 1}`}
                  className="photo-img"
                  loading="lazy"
                  onError={(e) =>
                    console.error("Image load failed:", photo.url)
                  }
                />

                {photo.caption && (
                  <div className="photo-caption">{photo.caption}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoVaultPhotosItems;
